///<reference path="../../../docsAndForms/docs-and-forms.models.ts"/>
///<reference path="../../../docsAndForms/docs-and-forms.service.ts"/>
module Meevo.Plugins.AppointmentBook {

    import IDocsAndFormsService = Meevo.Plugins.DocsAndForms.IDocsAndFormsService;
    import IClientFormService = Meevo.Plugins.DocsAndForms.IClientFormService;
    import IShowFormOptionRow = Meevo.Plugins.DocsAndForms.IShowFormOptionRow;
    import SecurityEntityTypeEnum = Meevo.Model.SecurityEntityTypeEnum;

    export enum FormCollectionStateEnum {
        Booking,
        Checkin,
        SmartAssistant
    }

    interface IFormService {
        serviceDisplayName: string;
        startDateTime: string;
        forms: IClientFormService[];
        serviceId: string;
    }

    class DocsAndFormsController {
        isListMode: boolean = true;
        form;
        headerKey: string;
        clients: any[];
        url: string;

        static $inject = [
            'meevo.AppSettings',
            "$mdDialog",
            "$sce",
            "meevo.components.common.DataService",
            'forms',
            'formCollectionState',
            "request",
            "appointmentServices",
            'meevo.plugins.docsAndForms.DocsAndFormsService',
            'meevo.components.busy.BusyService',
            'meevo.components.modal.ModalService',
            '$translate',
            '$rootScope',
            'iframeCallback'
        ];

        constructor(
            private appSettings: Meevo.Components.Common.IAppSettings,
            private $mdDialog,
            private $sce,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            private forms: any[],
            private formCollectionState: FormCollectionStateEnum,
            private request,
            private appointmentServices,
            private docsAndFormsService: IDocsAndFormsService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $translate: angular.translate.ITranslateService,
            protected $rootScope: angular.IRootScopeService,
            private iframeCallback
        ) {
            if (forms.length == 0) {
                this.headerKey = "MESSAGE_NO_FORMS";
            }
            else if (formCollectionState == FormCollectionStateEnum.Booking) {
                this.headerKey = "MESSAGE_FORM_BOOKING";
            }
            else if (formCollectionState == FormCollectionStateEnum.Checkin) {
                this.headerKey = "MESSAGE_FORM_REQUIRED";
            }
            this.buildClients();
        }

        private buildClients() {
            this.docsAndFormsService
                .buildFormsAndClients(this.forms, this.appointmentServices, this.formCollectionState)
                .then(clients => {
                    this.clients = clients;
                });
        }

        private refresh() {
            this.dataService.customMethodData("api/DocsAndForms/AppointmentServiceForm/List", "post", this.request).then(response=> {
                this.forms = response.data;
                this.buildClients();
            });
        }

        loadForm(form: IClientFormService) {
            const showFormRow: IShowFormOptionRow = {
                formDisplayName: form.displayName,
                formId: form.id,
                formUrl: form.formUrl,
                serviceId: form.appointmentServiceId
            };

            this.close();
            this.docsAndFormsService.showForm(showFormRow, form.clientId, form.appointmentId, this.iframeCallback);
        }

        openPdf(url: string) {
            window.open(url, '_blank');
        }

        resendForm(form) {
            this.busyService.start();

            const request = {
                clientId: form.clientId,
                formId: form.id, // form.id matches id used by Client Docs & Forms resendForm method
                appointmentId: form.appointmentId,
                appointmentServiceId: form.appointmentServiceId
            };

            this.dataService.add('DocsAndForms/ResendClientForm', request)
                .then(() => {
                    this.busyService.stop();

                    const message = this.$translate.instant('MESSAGE_FORM_SENT', {
                        formDisplayName: form.displayName
                    });

                    // Need to hide so don't see unsightly transparent affect when following modal is closed
                    $("#docs-modal").hide();
                    this.modalService.message(message, Components.Modal.ModalTranslationModes.DoNotTranslate, true).then(() => {
                        this.close();
                    })
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        close() {
            if (this.isListMode) {
                this.$mdDialog.hide();
            }
            else {
                this.refresh();
                this.isListMode = true;
            }
        }

        public goToClient(clientId: string) {
            var actionStateParam = Meevo.Model.MaintenanceFormState.Readonly;
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    callback: null,
                    callbackState: null,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: actionStateParam,
                    id: clientId
                },
            });
            this.close();
        }
    }

    angular.module("ApptBookApp")
        .controller("meevo.plugins.appointmentBook.DocsAndFormsController", DocsAndFormsController);
}
